// extracted by mini-css-extract-plugin
export default {"header":"kwOgl2","brand":"WLVV7M","userArea":"C7OvHT","iconLink":"XYZ8vH","logout":"r0ZtdS"};